/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ShipperTarget } from '../../models/shipper-target';
import { UpdateShipperTargetDto } from '../../models/update-shipper-target-dto';

export interface UpdateOneBaseMgmtShipperTargetControllerShipperTarget$Params {
  shipperId: number;
  id: number;
      body: UpdateShipperTargetDto
}

export function updateOneBaseMgmtShipperTargetControllerShipperTarget(http: HttpClient, rootUrl: string, params: UpdateOneBaseMgmtShipperTargetControllerShipperTarget$Params, context?: HttpContext): Observable<StrictHttpResponse<ShipperTarget>> {
  const rb = new RequestBuilder(rootUrl, updateOneBaseMgmtShipperTargetControllerShipperTarget.PATH, 'patch');
  if (params) {
    rb.path('shipperId', params.shipperId, {});
    rb.path('id', params.id, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ShipperTarget>;
    })
  );
}

updateOneBaseMgmtShipperTargetControllerShipperTarget.PATH = '/api/mgmt/shipper/{shipperId}/targets/{id}';
